import React from 'react';
import { PropTypes } from 'prop-types';

import { constants as aditionalOptionsConstants } from 'utils/aditionalOptions';
import { constants as orderConstants } from 'utils/order';
import { constants as dateAndTimeConstants } from 'utils/dateAndTimes';

import AditionalOption from 'components/summary/AditionalOption';

const OPTIONS = [
  aditionalOptionsConstants.ADITIONAL_OPTIONS.COMMENT_FOR_TRANSPORTIST,
  aditionalOptionsConstants.ADITIONAL_OPTIONS.INTERNAL_REFERENCE,
];

const getOptions = ({ orderType, stopType }) => {
  if (
    (orderType === orderConstants.DISTRIBUTION &&
      stopType === dateAndTimeConstants.STOP_TYPES.pickup) ||
    (orderType === orderConstants.COLLECTION &&
      stopType === dateAndTimeConstants.STOP_TYPES.dropoff)
  )
    return [
      aditionalOptionsConstants.ADITIONAL_OPTIONS.COMMENT_FOR_TRANSPORTIST,
    ];

  return OPTIONS;
};

const MRAditionalOptions = ({
  className,
  shipmentKey,
  stopType,
  t,
  orderType,
}) => (
  <div className={className}>
    {[...getOptions({ orderType, stopType })].map((option) => (
      <AditionalOption
        key={option}
        name={option}
        shipmentKey={shipmentKey}
        stopType={stopType}
        t={t}
      />
    ))}
  </div>
);

MRAditionalOptions.propTypes = {
  className: PropTypes.string,
  shipmentKey: PropTypes.string.isRequired,
  stopType: PropTypes.string.isRequired,
  orderType: PropTypes.string.isRequired,
  t: PropTypes.func,
};

MRAditionalOptions.defaultProps = {
  className: '',
  t: () => {},
};

export default MRAditionalOptions;
